export default __webpack_public_path__ + "5fcc0f8e85b35000bfd83ae765187dbe.woff";